export var SliceStatus;
(function (SliceStatus) {
    SliceStatus["IDLE"] = "idle";
    SliceStatus["PENDING"] = "pending";
})(SliceStatus || (SliceStatus = {}));
